import { useId, type ReactNode } from 'react';
import { cn, PaletteUtils } from '@shared/utils';
import { Text } from '../text';

interface SwitcherProps {
  className?: string;
  label?: ReactNode;
  value?: boolean;
  onChange?: (value: boolean) => void;
}

export const Switcher = (props: SwitcherProps) => {
  const id = useId();

  return (
    <div className={cn(props.className)}>
      <label htmlFor={id} className='ml-auto inline-flex cursor-pointer items-center'>
        {props.label && (
          <Text className='mx-3 my-auto whitespace-nowrap' color={PaletteUtils.isVcfcPalette ? 'white-gray' : 'secondary'}>
            {props.label}
          </Text>
        )}
        <input id={id} className='peer sr-only' type='checkbox' checked={props.value} onChange={(e) => props.onChange?.(e.target.checked)} />
        <div
          className={cn(
            'bg-gray-200 dark:bg-gray-700 peer relative h-6 w-11 rounded-full',
            'peer-checked:after:translate-x-full peer-checked:after:border-white',
            'after:absolute after:start-[2px] after:top-[2px] after:border after:border-light-telegray after:bg-white',
            'dark:border-gray-600 bg-very-pale-blue after:h-5 after:w-5 after:rounded-full after:transition-all peer-checked:bg-primary',
            'peer-focus:outline-none peer-focus:ring-1 peer-focus:ring-gothic',
            PaletteUtils.isVcfcPalette &&
              'shadow-[0_2px_10px_0_rgba(8,9,101,0.06)] backdrop-blur transition-all duration-300 ease-in-out after:absolute after:start-[2px] after:top-[2px] after:border-none after:bg-white hover:bg-[#DADAD9]/90 peer-checked:dark:bg-primary',
          )}
        />
      </label>
    </div>
  );
};
